import { render, staticRenderFns } from "./Automation.vue?vue&type=template&id=d61d49c6&scoped=true"
import script from "./Automation.vue?vue&type=script&lang=js"
export * from "./Automation.vue?vue&type=script&lang=js"
import style0 from "./Automation.vue?vue&type=style&index=0&id=d61d49c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61d49c6",
  null
  
)

export default component.exports